import { TweenMax } from 'gsap';
import { GameItemConfig, ItemIDs } from '../../../Config/Items';
import Core from '../../../Core/Core';
import { createFrameList, createOutlineText } from '../../../Utils/Utils';
import { AnimatedSprites } from '../AnimatedSprites';
import { Animation } from '../Animation';

export class BoosterTime extends AnimatedSprites {
    private text: PIXI.Text;

    constructor(scale: number) {
        super(scale, createFrameList('boosterfx/booster-time-VFX', 48));
        const text = (this.text = createOutlineText(
            `+${GameItemConfig[ItemIDs.TIME].strength} ${Core.local.getText('seconds')}`,
            new PIXI.Rectangle(
                0,
                this.sprite.height / 3,
                this.sprite.width * 1.5,
                this.sprite.height * 0.3
            ),
            'Baloo',
            30,
            21,
            0xffffff,
            0x053391,
            4
        ));
        this.sprite.addChild(text);
    }

    public play(cb?: () => void) {
        const animation = new Animation({});
        animation.add(
            TweenMax.to(this.text, 1, {
                y: this.sprite.height / 4,
            })
        );
        animation.add(TweenMax.to(this.text, 0.2, { alpha: 0 }));
        animation.play();
        const callback = () => {
            animation.kill();
            cb();
        };
        super.play(callback);
    }
}
